

































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ImageUploader from "vue-image-upload-resize";
import formatter from "@/mixins/formatter";
import { AxiosResponse } from "axios";
import { StockMarket } from "@/smartmsi";
import MField from "@/components/MField.vue";
import Field from "@/components/Field.vue";
import LegalTypologyForm from '@/pages/company/LegalTypologyForm.vue'
import { AuthUser } from "@/smartmsi";
import { State } from "vuex-class";


@Component({
  components: { Field, MField, ImageUploader, LegalTypologyForm },
  mixins: [formatter],
})
export default class CompanyForm extends Vue {
  @State user!: AuthUser;

  company = null;
  legalTypologies = [];
  stockMarkets: StockMarket[] = [];
  editDialog = false;

  contactTemplate = {
    gender: null,
    name: "",
    title: "",
    phone: "",
    email: "",
  };
  countries = [];

  created() {
    // load lists
    this.$api
      .get("legal-typology?per-page=0")
      .then(j => (this.legalTypologies = j.data));
    this.$api.get("country?per-page=0").then(j => (this.countries = j.data));
    this.$api
      .get("stock-market?per-page=0")
      .then(
        (res: AxiosResponse<StockMarket[]>) => (this.stockMarkets = res.data)
      );

    // get or create company object
    if (this.companyId) {
      this.$api
        .get(`company/${this.companyId}?expand=companyActivities`)
        .then(j => {
          this.company = j.data;
          if (this.company.profil_fmp.length == 0) {
            this.company.profil_fmp = {
              currency: ""
            };
          }
        });
    } else {
      this.company = {
        name: "",
        url: "",
        image: false,
        companyActivities: [{}],
        contacts: [{}],
        profil_fmp: { currency: "" }
      };
    }
  }
  createModel() {
    this.editDialog = true;
  }
  onDialogSave() {
    this.editDialog = false;
    this.$api
      .get("legal-typology?per-page=0")
      .then(j => (this.legalTypologies = j.data));
  }
  onSubmit() {
    const call = this.companyId
      ? this.$api.patch(`company/${this.companyId}`, this.company)
      : this.$api.post(`company`, this.company);

    call
      .then(j => {
        this.$router.push(`/company/${j.data.id}`);
      })
      .catch(err => {
        if (err.response) this.$refs.form.setErrors(err.response.data);
        this.$snack.validationError(err.response.data);
      });
  }

  addActivity() {
    this.$set(this.company, "companyActivities", [
      ...(this.company.companyActivities || []),
      {
        activity_id: null,
        percent: null,
      },
    ]);
  }

  addContact() {
    this.company.contacts = [
      ...this.company.contacts,
      { ...this.contactTemplate },
    ];
  }

  removeContact(index: number) {
    this.$delete(this.company.contacts, index);
  }

  setImage(newImage) {
    this.company = { ...this.company, newImage };
  }

  get rules() {
    return this.$store.state.rules;
  }
}
